module.exports = __webpack_public_path__ + "static/media/8.d3df3280.jpg";